import React, { FC } from 'react';
import { IWizardProps } from 'types/wizard';
import Preview from '../Pages/Integrate/WizardPreviewPage';

const Integrate: FC<IWizardProps> = (props) => <Preview {...props} />;

export default Integrate;
